import React from "react";
import {
  Filter,
  Create,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  SaveButton,
  BooleanInput,
  List,
  DateField,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton,
  required,
  minLength,
  SelectInput,
  ReferenceField
} from "react-admin";
import { prop } from "ramda";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import styled from "styled-components";
import { ROLES } from "../rbac";

const StyledH3 = styled.h3`
  width: 100% !important;
`;

const role = ROLES;

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const UserTitle = object => (
  <span>
    {" Edit User entry "} {object.record.email}
  </span>
);

const UserCreateTitle = () => <span>Create User entry</span>;

const UsersListFilter = props => (
  // <Filter {...props}>
  //   <TextInput label="Email" source="email" alwaysOn />
  //   <BooleanInput source="isAdmin" label="Admin" alwaysOn />
  //   <BooleanInput source="isFinancial" label="Financial Data" alwaysOn />
  //   <BooleanInput source="isGuide" label="Guide" alwaysOn />
  //   <BooleanInput source="isAgency" label="Agency" alwaysOn />
  //   <BooleanInput source="isAgent" label="Agent" alwaysOn />
  //   <BooleanInput source="isBase" label="Base" alwaysOn />
  //   <BooleanInput source="isManager" label="Manager" alwaysOn />
  //   <BooleanInput source="isMaster" label="Master" alwaysOn />
  // </Filter>

  <Filter {...props}>
  <TextInput label="Email" source="email" alwaysOn />
  <SelectInput
    label="Profiles"
    source="role" 
    choices={role} 
    optionText="name" 
    optionValue="id" 
    alwaysOn
  />
  </Filter>

);

export const UsersList = props => (
  <List
    {...props}
    title="Users"
    resource="users"
    bulkActionButtons={false}
    pagination={<ListPagination />}
    filters={<UsersListFilter />}
  >
    <Datagrid>
      <TextField label="ID" source="id" />
      <TextField label="Email" source="email" />
      <FunctionField
        label="Profile"
        render={user => {
          // return user.isBase ? "Yes" : "No";
          return (role.find(r => r.id === user.role)).name;
        }}
      />

      {/* <FunctionField
        label="Admin"
        render={user => {
          return user.isAdmin ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Base"
        render={user => {
          return user.isBase ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Manager"
        render={user => {
          return user.isManager ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Master"
        render={user => {
          return user.isMaster ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Financ. Data"
        render={user => {
          return user.isFinancial ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Agency"
        render={user => {
          return user.isAgency ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Agent"
        render={user => {
          return user.isAgent ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Guide"
        render={user => {
          return user.isGuide ? "Yes" : "No";
        }}
      /> */}
      <DateField source="confirmed_at" />
      <EditButton />
    </Datagrid>
  </List>
);

const UsersToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/users`} />
    <Button
      component={Link}
      to={{
        pathname: `/users`
      }}
      label="Back to Users"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

export const UsersEdit = props => (
  <Edit title={<UserTitle />} {...props}>
    <SimpleForm
      toolbar={<UsersToolbar props={{ ...props }} />}
      resource="users"
    >
      <TextField label="Email" source="email" validate={required()} />
      <DateField source="confirmed_at" />

      <ReferenceInput
        label="Location"
        source="location_id"
        reference="locations"
        sort={{ field: "screen_order", order: "ASC" }}
      >
        <AutocompleteInput optionText={l => `${l.location_name}`} />
      </ReferenceInput>

      <StyledH3>Profiles (Regular user has no associated profiles)</StyledH3>

      <SelectInput
        label="Profile"
        source="role"
        choices={role} 
        optionText="name" 
        optionValue="id" 
      />

      {/* <BooleanInput
        source="isAdmin"
        style={{ width: "100%" }}
        label="Admin (with access to all edits)"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isMaster"
        label="Master (all access except deep configuration)"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isManager"
        label="Manager (all access except future stats)"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isBase"
        label="Base - Base (All view access and can edit bike km, charge km extra, edit revisions, maintenance and tires))"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isFinancial"
        label="Financial Data (Access to bikes prices, etc)"
      />
      <BooleanInput source="isGuide" label="Guide" />
      <BooleanInput source="isAgency" label="Agency" />
      <BooleanInput source="isAgent" label="Agent" />*/}
    </SimpleForm> 
  </Edit>
);

const validateForm = values => {
  const errors = {};
  if (
    values &&
    prop("password", values) !== prop("password_confirmation", values)
  ) {
    errors.password = ["Password and password confirmation mismatch"];
  }
  return errors;
};

export const UsersCreate = props => (
  <Create title={<UserCreateTitle />} {...props}>
    <SimpleForm
      toolbar={<UsersToolbar props={{ ...props }} />}
      validate={validateForm}
    >
      <TextInput
        label="Email"
        source="email"
        type="email"
        validate={[required()]}
      />
      <TextInput
        label="Password"
        source="password"
        type="password"
        validate={minLength(8)}
      />
      <TextInput
        label="Password Confirmation"
        source="password_confirmation"
        type="password"
        validate={minLength(8)}
      />

      <ReferenceInput
        validate={[required()]}
        label="Location"
        source="location_id"
        reference="locations"
        sort={{ field: "screen_order", order: "ASC" }}
      >
        <AutocompleteInput optionText={l => `${l.location_name}`} />
      </ReferenceInput>

      <SelectInput
        label="Profiles"
        source="role"
        choices={role} 
        optionText="name" 
        optionValue="id" 
      />

      {/* <StyledH3>Profiles (Regular user has no associated profiles)</StyledH3>
      <BooleanInput
        source="isAdmin"
        style={{ width: "100%" }}
        label="Admin (with access to all edits)"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isMaster"
        label="Master (all access except deep configuration)"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isManager"
        label="Manager (all access except future stats)"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isBase"
        label="Base - Base (All view access and can edit bike km, charge km extra, edit revisions, maintenance and tires))"
      />
      <BooleanInput
        style={{ width: "100%" }}
        source="isFinancial"
        label="Financial Data (Access to bikes prices, etc)"
      />
      <BooleanInput source="isGuide" label="Guide" />
      <BooleanInput source="isAgency" label="Agency" />
      <BooleanInput source="isAgent" label="Agent" /> */}
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/users.js